<template>
  <button v-if="details" class="text-left w-full" @click="modalOpen = true">
    <MLabel
      class="border rounded-12 flex"
      :class="{ 'relative cursor-pointer hover:underline': details }"
      :type="type"
    >
      <p class="text-14">
        <span v-if="messageKey" class="font-semibold">{{ $t(messageKey) }}</span>
        <span class="underline ml-1">{{ $t('details') }}</span>
      </p>
      <MModal v-if="details && modalOpen" @close="modalOpen = false">
        <p class="m-8">{{ details }}</p>
      </MModal>
    </MLabel>
  </button>
</template>

<script lang="ts" setup>
import type { Provider } from '../types'
import type { LabelType } from '@core/components/m-label/types'

const props = defineProps<{
  provider: Provider
  type: LabelType
  messageKey?: string
  detailsText?: string
}>()

const modalOpen = ref(false)

const { $t, $i18next } = useNuxtApp()
const details = computed(() => {
  if (props.detailsText) {
    return props.detailsText
  }
  if (props.messageKey && $i18next.exists(`${props.messageKey}_details`)) {
    return $t(`${props.messageKey}_details`)
  }
  return false
})
</script>
